<template>
  <div>
    <div class="card card-custom gutter-b card-stretch">
      <!--begin::Header-->
      <div class="card-header border-0 py-5">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label font-weight-bolder text-dark">
            Absensi Laporan Harian {{ getToday() }}
          </span>
          <span class="text-muted mt-3 font-weight-bold font-size-sm">
            Daftar KaKo yang sudah atau belum melapor
          </span>
        </h3>
        <div class="card-toolbar">
          Download data
          <b class="ml-1">per kemarin</b>
          :
          <b-button
            v-if="downloadYesteradyData"
            class="btn-sm ml-3"
            @click="handleDownload('harian_kemarin')"
          >
            Harian
          </b-button>
          <b-button
            v-if="downloadCumulativeYesterdayData"
            class="btn-sm ml-3"
            @click="handleDownload('kumulatif_kemarin')"
          >
            Kumulatif
          </b-button>
          <span
            class="bullet bullet-bar bg-default align-self-stretch ml-3 mr-3"
          />
          Download data per hari ini:
          <b-button
            v-if="downloadData"
            variant="success"
            class="btn-sm ml-3"
            @click="handleDownload('harian')"
          >
            Harian
          </b-button>
          <b-button
            v-if="downloadCumulativeData"
            variant="danger"
            class="btn-sm ml-3"
            @click="handleDownload('kumulatif')"
          >
            Kumulatif
          </b-button>
        </div>
      </div>
      <!--end::Header-->
      <!--begin::Body-->
      <div class="card-body py-0 pb-10">
        <!-- <div>
          Sorting By:
          <b>{{ sortBy }}</b>
          , Sort Direction:
          <b>{{ sortDesc ? 'Descending' : 'Ascending' }}</b>
        </div> -->
        <b-table
          responsive
          striped
          hover
          :items="myProvider"
          :busy.sync="isBusy"
          :fields="fields"
          class="mt-3"
          outlined
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :no-provider-sorting="true"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle" />
              <strong>Loading...</strong>
            </div>
          </template>

          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>

          <template #cell(status)="data">
            <span
              class="label label-md label-inline font-weight-bold py-5"
              :class="
                data.value === 'SUDAH LAPOR' ? 'label-primary' : 'label-danger'
              "
            >
              {{ data.value }}
            </span>
          </template>
        </b-table>
      </div>
      <!--end::Body-->
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { today, yesterday } from '@/core/helpers/temp/util.js'

export default {
  components: {},
  data() {
    return {
      sortBy: 'status',
      sortDesc: true,
      isBusy: false,
      fields: [
        'index',
        {
          key: 'provinsi',
          sortable: true,
        },
        {
          key: 'kabupaten',
          sortable: true,
        },
        {
          key: 'capaian_harian_dosis_1',
          sortable: false,
        },
        {
          key: 'capaian_harian_dosis_2',
          sortable: false,
        },
        {
          key: 'capaian_harian_dosis_3',
          sortable: false,
        },
        {
          key: 'sdmkes_dosis_1',
          label: 'SDMKES Dosis 1',
          sortable: false,
        },
        {
          key: 'sdmkes_dosis_2',
          label: 'SDMKES Dosis 2',
          sortable: false,
        },
        {
          key: 'sdmkes_dosis_3',
          label: 'SDMKES Dosis 3',
          sortable: false,
        },
        {
          key: 'pet_pub_dosis_1',
          sortable: false,
        },
        {
          key: 'pet_pub_dosis_2',
          sortable: false,
        },
        {
          key: 'pet_pub_dosis_3',
          sortable: false,
        },
        {
          key: 'lansia_dosis_1',
          sortable: false,
        },
        {
          key: 'lansia_dosis_2',
          sortable: false,
        },
        {
          key: 'lansia_dosis_3',
          sortable: false,
        },
        {
          key: 'masy_rentan_umum_dosis_1',
          label: 'Masy Rentan & Umum Dosis 1',
          sortable: false,
        },
        {
          key: 'masy_rentan_umum_dosis_2',
          label: 'Masy Rentan & Umum Dosis 2',
          sortable: false,
        },
        {
          key: 'masy_rentan_umum_dosis_3',
          label: 'Masy Rentan & Umum Dosis 3',
          sortable: false,
        },
        {
          key: 'usia_12-17_dosis_1',
          sortable: false,
        },
        {
          key: 'usia_12-17_dosis_2',
          sortable: false,
        },
        {
          key: 'usia_6-11_dosis_1',
          sortable: false,
        },
        {
          key: 'usia_6-11_dosis_2',
          sortable: false,
        },
        {
          key: 'status',
          sortable: true,
          thStyle: { width: '10%' },
        },
      ],
      // download
      downloadData: [], // data harian per hari ini
      downloadCumulativeData: [], // data kumulatif per hari ini
      downloadYesteradyData: [], // data harian per kemarin
      downloadCumulativeYesterdayData: [], // data kumulatif per kemarin
      // filename: `data_harian`,
      autoWidth: true,
      bookType: 'xlsx',
    }
  },
  async mounted() {
    await this.fetchData()
  },
  watch: {
    $route: 'fetchData',
  },

  methods: {
    fetchData() {
      const apiUrl = process.env.VUE_APP_SERVICE_URL
      // get report - up to today
      axios
        .get(`${apiUrl}/api/cluster_immunization/fetch_reports`, {
          params: {
            report: 'v_report_cumulative_upto_today',
          },
        })
        .then((res) => {
          // console.log(res)
          this.downloadCumulativeData = Object.freeze(res.data.items)
        })
        .catch((err) => {
          console.log(err)
        })

      // get report - up to yesterday
      axios
        .get(`${apiUrl}/api/cluster_immunization/fetch_reports`, {
          params: {
            report: 'v_report_cumulative_upto_yesterday',
          },
        })
        .then((res) => {
          // console.log(res)
          this.downloadCumulativeYesterdayData = Object.freeze(res.data.items)
        })
        .catch((err) => {
          console.log(err)
        })

      // get report - daily data of yesterday
      axios
        .get(`${apiUrl}/api/cluster_immunization/fetch_reports`, {
          params: {
            report: 'v_report_daily_yesterday',
          },
        })
        .then((res) => {
          // console.log(res)
          this.downloadYesteradyData = Object.freeze(res.data.items)
        })
        .catch((err) => {
          console.log(err)
        })
    },

    myProvider() {
      // Here we don't set isBusy prop, so busy state will be
      // handled by table itself
      this.isBusy = true
      const apiUrl = process.env.VUE_APP_SERVICE_URL
      let promise = axios.get(
        `${apiUrl}/api/cluster_immunization/todays_report`
      )

      return promise
        .then((data) => {
          const items = data.data.items
          // console.log(items)
          // Here we could override the busy state, setting isBusy to false
          this.isBusy = false
          this.downloadData = items
          return items
        })
        .catch((error) => {
          // Here we could override the busy state, setting isBusy to false
          this.isBusy = false
          console.log(error)
          // Returning an empty array, allows table to correctly handle
          // internal busy state in case of error
          return []
        })
    },
    getToday() {
      return today()
    },

    test(param) {
      console.log(param)
    },

    // download data harian
    handleDownload(param) {
      this.downloadLoading = true
      import('@/core/helpers/Export2Excel').then((excel) => {
        const tHeader = [
          'Id Kabupaten',
          'Kabupaten',
          'Id Provinsi',
          'Provinsi',
          'Capaian Harian Dosis 1',
          'Capaian Harian Dosis 2',
          'Capaian Harian Dosis 3',
          'Lansia Dosis 1',
          'Lansia Dosis 2',
          'Lansia Dosis 3',
          'Petugas Publik Dosis 1',
          'Petugas Publik Dosis 2',
          'Petugas Publik Dosis 3',
          'SDMKES Dosis 1',
          'SDMKES Dosis 2',
          'SDMKES Dosis 3',
          'Masy Rentan & Umum Dosis 1',
          'Masy Rentan & Umum Dosis 2',
          'Masy Rentan & Umum Dosis 3',
          'Usia 12-17 Dosis 1',
          'Usia 12-17 Dosis 2',
          'Usia 6-11 Dosis 1',
          'Usia 6-11 Dosis 2',
          'Status',
        ]

        let filterVal
        const filterValBody = [
          'id_kabupaten',
          'kabupaten',
          'id_provinsi',
          'provinsi',
          'capaian_harian_dosis_1',
          'capaian_harian_dosis_2',
          'capaian_harian_dosis_3',
          'lansia_dosis_1',
          'lansia_dosis_2',
          'lansia_dosis_3',
          'pet_pub_dosis_1',
          'pet_pub_dosis_2',
          'pet_pub_dosis_3',
          'sdmkes_dosis_1',
          'sdmkes_dosis_2',
          'sdmkes_dosis_3',
          'masy_rentan_umum_dosis_1',
          'masy_rentan_umum_dosis_2',
          'masy_rentan_umum_dosis_3',
          'usia_12-17_dosis_1',
          'usia_12-17_dosis_2',
          'usia_6-11_dosis_1',
          'usia_6-11_dosis_2',
          'status',
        ]

        const filterValBodyCumulative = [
          'id_kabupaten',
          'kabupaten',
          'id_provinsi',
          'provinsi',
          'capaian_harian_dosis_1',
          'capaian_harian_dosis_2',
          'capaian_harian_dosis_3',
          'lansia_dosis_1',
          'lansia_dosis_2',
          'lansia_dosis_3',
          'petugas_publik_dosis_1',
          'petugas_publik_dosis_2',
          'petugas_publik_dosis_3',
          'sdmkes_dosis_1',
          'sdmkes_dosis_2',
          'sdmkes_dosis_3',
          'masy_umum_dan_rentan_dosis_1',
          'masy_umum_dan_rentan_dosis_2',
          'masy_umum_dan_rentan_dosis_3',
          'usia_12-17_dosis_1',
          'usia_12-17_dosis_2',
          'usia_6-11_dosis_1',
          'usia_6-11_dosis_2',
          'status',
        ]

        let list = []
        let filename = ''

        switch (param) {
          case 'harian':
            list = this.downloadData
            filename = 'vc19_harian_' + today()
            filterVal = filterValBody
            break
          case 'kumulatif':
            list = this.downloadCumulativeData
            filename = 'vc19_kumulatif_' + today()
            filterVal = filterValBodyCumulative
            break
          case 'harian_kemarin':
            list = this.downloadYesteradyData
            filename = 'vc19_harian_' + yesterday()
            filterVal = filterValBody
            break
          default:
            list = this.downloadCumulativeYesterdayData
            filename = 'vc19_kumulatif_' + yesterday()
            filterVal = filterValBodyCumulative
        }

        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: filename,
          autoWidth: this.autoWidth,
          bookType: this.bookType,
        })
        this.downloadLoading = false
      })
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j]
        })
      )
    },
  },
}
</script>

<style lang="scss" scoped></style>
